if (window.location.pathname.includes('/products/')) {
  var SPRY_ALL_PRODUCT_VARIANTS = []
  var SPRY_PRODUCT;
  function SpryShowPriceVariantSelectInit() {
    const handle = window.location.pathname.split('/products/')[1]?.split('/')[0];
    const selectedId = document.querySelector('[name="id"]').value;
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        SPRY_PRODUCT = product;
        SPRY_ALL_PRODUCT_VARIANTS = product.variants
        const variant = product.variants.find(v => v.id == selectedId);
        if (variant) {
          const price = SpryFormatShopifyPrice(variant.price);
          // const btnEl = document.querySelector('.option-selector button.custom-select__btn');

          // Create a new element
          // const newDiv = document.createElement('strong');
          // newDiv.textContent = '';
          // newDiv.className = 'btn-selected-custom-price-appended-box';
          
          // btnEl.insertAdjacentElement('afterend', newDiv);
          // const btnElPrice = document.querySelector('.btn-selected-custom-price-appended-box');
          // btnElPrice.innerHTML = `${price}`;

          document.querySelectorAll('.option-selector ul.custom-select__listbox li').forEach(function (box, index) {
            const variantValue = box.getAttribute('data-value');
            console.log('variantValue', variantValue);
            const getVariantCheck = SPRY_ALL_PRODUCT_VARIANTS.find(v => (v.option2 == variantValue && v.option1 == variant.option1 ) );
            if (getVariantCheck) {
              const priceItem = SpryFormatShopifyPrice(getVariantCheck.price);
              // const content = box.textContent
              box.innerHTML = `<span class="pointer-events-none new">${variantValue}</span><span class="pointer-events-none--price">${priceItem}</span>`
            }
          });

          SpryShowPriceVariantSelectTriggerClick();
    
        }
      });
  }
  function SpryShowPriceVariantSelect() {
   
    const selectedId = document.querySelector('[name="id"]').value;
        const product = SPRY_PRODUCT
        setTimeout(function() {
             const variant = product.variants.find(v => v.id == selectedId);
            if (variant) {
              const price = SpryFormatShopifyPrice(variant.price);
              
              // const btnElPrice = document.querySelector('.btn-selected-custom-price-appended-box');
              // btnElPrice.innerHTML = `${price}`;
              document.querySelectorAll('.option-selector ul.custom-select__listbox li').forEach(function (box, index) {
                const variantValue = box.getAttribute('data-value');
                const getVariantCheck = SPRY_ALL_PRODUCT_VARIANTS.find(v => (v.option2 == variantValue && v.option1 == variant.option1 ) );
                if (getVariantCheck) {
                  const priceItem = SpryFormatShopifyPrice(getVariantCheck.price);
                  box.innerHTML = `<span class="pointer-events-none new">${variantValue}</span><span class="pointer-events-none--price">${priceItem}</span>`
                }
              });
        
            }
        }, 0);
       
  }

  function SpryFormatShopifyPrice(cents, currency = 'USD') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    }).format(cents / 100);
  }

  function spryHandleClickBtnSelect() {
    console.log('spryHandleClickBtnSelect');
    const selectBox = document.querySelector('.option-selector custom-select');
    if (selectBox) {
      const btn = selectBox.querySelector('button.custom-select__btn');
      if (btn) {
        ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(type => {
        const event = new MouseEvent(type, {
          bubbles: true,
          cancelable: true,
          view: window
        });
        btn.dispatchEvent(event);
      });
      }
    }
    
  }
  function SpryShowPriceVariantSelectTriggerClick() {
    const elementPriceClick = document.querySelector('.btn-selected-custom-price-appended-box');
    if (elementPriceClick) {
      console.log('SpryShowPriceVariantSelectTriggerClick');
      elementPriceClick.addEventListener('click', spryHandleClickBtnSelect);
     
    }
  }
  
  document.addEventListener('DOMContentLoaded', function () {
    SpryShowPriceVariantSelectInit();
    
  });
  document.querySelector('form[action*="/cart/add"]').addEventListener('change', function () {
    SpryShowPriceVariantSelect();
  });
}